<template>
    <div class="login-bg" :style="'background-image:url(' + bgimg_url + ');'">
        <div class="login-title">
            <img :src="supplier_logo" alt="">
            <span>{{ supplier_name }}</span>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="0px" class="demo-ruleForm login-container">
            <h2 class="title" style="margin-bottom: 20px;">找回密码</h2>
            <el-form-item prop="mobile">
                <el-select v-model="data1" style="width: 30%">
                    <el-option
                        v-for="item in options"
                        :label="item.text"
                        :key="item.value"
                        :value="item.value">
                    </el-option>
                </el-select>
                <el-input type="text" maxlength="11" placeholder="请输入手机号" v-model="ruleForm.mobile" style="width: 65%" />
            </el-form-item>
            <el-form-item prop="code">
                <div class="verify-wrapper">
                    <el-input type="text" maxlength="6" placeholder="请输入短信验证码" v-model="ruleForm.code" style="width: 65%" />
                    <el-button style=" width: 30%; border: 0; border-bottom: 1px solid rgba(0, 0, 0, 0.12);" class="btn-orange" :disabled="disabled" @click.native.prevent="getCode" >{{ valiBtn }}</el-button>
                </div>
            </el-form-item>
            <el-form-item prop="password">
                <el-input type="password" show-password minlength="8" maxlength="20" placeholder="设置密码(8-20个字，包含字母和数字)" v-model="ruleForm.password" />
            </el-form-item>
            <el-form-item prop="repassword">
                <el-input type="password" show-password minlength="8" maxlength="20" placeholder="再次输入密码" v-model="ruleForm.repassword" />
            </el-form-item>
            <!--登录-->
            <el-form-item>
                <el-button type="primary" style="width:100%;" @click.native.prevent="SubmitFunc" :loading="logining">
                    确认修改
                </el-button>
            </el-form-item>

            <div class="logon-register">
                <div class="forget"></div>
                <div class="register">已有账号？<el-link :underline="false"style="color: #376ef0"@click.native.prevent="goLogin">登录</el-link></div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import IndexApi from '@/api/index.js';
    import bgimg from '@/assets/img/login_bg.png';
    import UserApi from '@/api/user.js';
    import { setCookie, setSessionStorage } from '@/utils/base.js';

    export default {
        data() {
            return {
                data1: 1,
                options: [{value: 1, text: "中国+86"}],
                valiBtn: "获取验证码",
                disabled: false,
                // 是否正在加载
                loading: true,
                // 系统名称
                supplier_name: '',
                // 系统logo
                supplier_logo: '',
                // 背景图片
                bgimg_url: '',
                // 是否正在提交
                logining: false,
                // 表单对象
                ruleForm: {
                    mobile: '',
                    code: '',
                    password: '',
                    repassword: '',
                },
                // 验证规则
                rules: {
                    mobile: [{required: true, message: '请输入手机号', trigger: 'blur'}],
                    code: [{required: true, message: '请输入短信验证码', trigger: 'blur'}],
                    password: [{required: true, message: '请输入密码', trigger: 'blur'}],
                    repassword: [{required: true, message: '请确认密码', trigger: 'blur'}],
                },
                // 基础配置
                baseData: {}
            };
        },
        created() {
            this.getData();
        },
        methods: {
            // 获取基础配置
            getData() {
                let self = this;
                IndexApi.base(true)
                    .then(res => {
                        self.loading = false;
                        self.baseData = res.data;
                        self.supplier_logo = res.data.settings.supplier_logo;
                        self.supplier_name = res.data.settings.supplier_name;
                        if (res.data.settings.supplier_bg_img != '') {
                            self.bgimg_url = res.data.settings.supplier_bg_img;
                        } else {
                            self.bgimg_url = bgimg;
                        }
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },

            // 发送短信
            getCode() {
                var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
                if (this.ruleForm.mobile == "") {
                    this.$message({
                        message: "请输入手机号",
                        type: "warning",
                    });
                } else if (!reg.test(this.ruleForm.mobile)) {
                    this.$message({
                        message: "手机号不合法",
                        type: "warning",
                    });
                } else {
                    this.logining = true;
                    var Params = {
                        mobile: this.ruleForm.mobile,
                        type: 'resetpassword',
                    };
                    UserApi.sendCode(Params, true)
                        .then((res) => {
                            this.logining = false;
                            if (res.code == 1) {
                                this.tackBtn(); //验证码倒数60秒
                                this.$message({
                                    message: "获取验证码成功",
                                });
                            } else {
                                this.$message({
                                    message: "获取失败",
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {
                            //接口调用方法统一处理
                            this.logining = false;
                        });
                }
            },
            tackBtn() {
                //验证码倒数60秒
                let time = 60;
                let timer = setInterval(() => {
                    if (time == 0) {
                        clearInterval(timer);
                        this.valiBtn = "获取验证码";
                        this.disabled = false;
                    } else {
                        this.disabled = true;
                        this.valiBtn = time + "秒后重试";
                        time--;
                    }
                }, 1000);
            },

            // 确认修改
            SubmitFunc(ev) {
                var that = this;
                that.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        that.logining = true;

                        UserApi.resetPassword(that.ruleForm, true)
                            .then(res => {
                                if (res.code == 1) {
                                    that.$message({
                                        message: '密码重置成功,请稍后~',
                                        type: 'success'
                                    });

                                    setTimeout(function () {
                                        // 跳转到首页
                                        that.logining = false;
                                        that.$router.push({path: "/login"});
                                    }, 2000);
                                } else {
                                    that.$message({
                                        message: '重置密码失败',
                                        type: 'error'
                                    });
                                }
                            })
                            .catch(error => {
                                // 接口调用方法统一处理
                                that.logining = false;
                            });
                    }
                });
            },

            // 去登录
            goLogin() {
                this.$router.push({path: "/login"});
            }
        }
    };
</script>

<style lang="scss" scoped>
    .login-bg {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
        .login-title{
            width: 100%;
            height: 75px;
            background-color: #409EFF;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
                width: 40px;
                height: 40px;
            }
            span{
                margin-left: 10px;
                font-size: 28px;
                font-weight: bold;
                color: #fff;
            }
        }
        .logon-register{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .register{
                cursor: pointer;
            }
            .forget{
                cursor: pointer;
            }
        }
    }

    .login-container {
        box-shadow: 0px 0px 2px 2px #66666640;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        -moz-border-radius: 5px;
        background-clip: padding-box;
        position: fixed;
        width: 450px;
        left: 50%;
        top: 40%;
        margin-left: -175px;
        margin-top: -175px;
        padding: 35px;
        background: #fff;
        border: 1px solid #eaeaea;

        .title {
            margin: 0px auto 40px auto;
            text-align: center;
            color: #505458;
        }

        .remember {
            margin: 0px 0px 35px 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/resetpassword.vue